var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1151.6 348.38-300-300c-3.375-3.375-7.5-6-12-8.25-4.875-1.5-9.75-2.625-14.625-2.625h-750c-20.625 0-37.5 16.875-37.5 37.5v1050c0 20.625 16.875 37.5 37.5 37.5h1050c20.625 0 37.5-16.875 37.5-37.5v-750c0-10.125-4.125-19.5-10.875-26.625zm-851.62-235.88h487.5v262.5h-487.5zm600 975h-600v-450h600zm187.5 0h-112.5v-487.5c0-20.625-16.875-37.5-37.5-37.5h-675c-20.625 0-37.5 16.875-37.5 37.5v487.5h-112.5v-975h112.5v300c0 20.625 16.875 37.5 37.5 37.5h562.5c20.625 0 37.5-16.875 37.5-37.5v-247.12l225 225z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.c9713ec175aa10981e0b91d4199dad92.svg";
export { ForwardRef as ReactComponent };